<div class="p-3 tasks">
  <div class="flex">
    <div (click)="openSidePanel(true)" class="card mr-2">
      <label class="card-header">Residents with therapy episodes</label>
      <div class="card-value">{{details?.openTEsCount ?? 0}}</div>
    </div>
    <div (click)="openSidePanel(false)" class="card card-2">
      <label class="card-header">Last Therapy Day Upcoming</label>
      <div class="flex">
        <div class="circle"(mouseenter)="showTooltip()" (mouseleave)="hideTooltip()">
          <span class="number">{{ displayValueLastTherapyDayUpComing ?? 0 }}</span>
          <span class="tooltip" *ngIf="isTooltipVisible">{{ details?.lastTherpayDateUpcomingCount ?? 0 }}</span>
        </div>
        <label class="align-content-center">
          Number of Patients
        </label>
      </div>
    </div>
  </div>
  <div class="flex mt-4">
    <div class="details mr-2">
      <label>LTC Residents</label>
      <div class="card-value font-medium">{{details?.ltcRecordsCount ?? 0 }}</div>
    </div>
    <div class="details mr-2">
      <label>Subacute Residents</label>
      <div class="card-value font-medium">{{details?.subAcuteRecordsCount ?? 0}}</div>
    </div>
  </div>
</div>  